/**
 * How the Home's Preview gadget (components/home/gadgets/PreviewGadget) draws the app inside its box: at a desktop
 * width (`DESKTOP_WIDTH`, or the box's own width when the box is wider), scaled down to the box's width, and as tall as
 * the box once scaled (`height / scale`), so a tall card shows more of the page instead of a short strip with empty
 * space under it. Recomputed whenever the box changes size (a ResizeObserver in the gadget).
 */
export const DESKTOP_WIDTH = 1280;

/**
 * `{ width, height }` of the box in CSS pixels → `{ scale, width, height }` of the iframe's virtual viewport, or null
 * while the box has no size yet (not laid out, hidden): the stylesheet's default then applies.
 */
export function previewFit({ width, height } = {}, desktopWidth = DESKTOP_WIDTH) {
  if (!(width > 0) || !(height > 0)) { return null; }
  const virtualWidth = Math.max(desktopWidth, width);
  const scale = width / virtualWidth;
  return { scale, width: virtualWidth, height: Math.ceil(height / scale) };
}
